import { render } from "./DevicePerformance.vue?vue&type=template&id=09aff4ba"
import script from "./DevicePerformance.vue?vue&type=script&lang=js"
export * from "./DevicePerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__